(()=>{
  "use strict";

  const observeUpdateOldFormat = () => {
    document.addEventListener('change', element => {
      if (element.target.matches('input[data-update-old-format]')) {
        let current_type_report = element.target.getAttribute('data-update-old-format');
        updateOldFormat(current_type_report, element.target.checked);
      }
    });
  };

  const updateOldFormat = (current_record, new_status) => {
    let url = `/parameterization/type_reports/${parseInt(current_record)}.json`,
        data = { type_report: { old_format: new_status } };

    try {
      fetch(url, {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content
          }),
          body: JSON.stringify(data)
        })
        .then(json => json.json())
        .then(info => {
          swal('Proceso Exitoso', 'Tipo de Reporte actualizado', 'success');
        })
        .catch(error => {
          swal('Error', 'No se pudo actualizar el tipo de reporte', 'error');
          return error;
        });
    } catch (error) {
      swal('There was a problem trying to connect to the server to retrieve the necessary data, please try again; if the error persists please contact our staff.');
      console.log(error);
    }
  };

  document.addEventListener('turbolinks:load', () => {
    observeUpdateOldFormat();
  });
})();